module.exports = __webpack_public_path__ + "static/media/25UNHCR1.fa26a1e1.jpg";